var collapsible_list_pair_rtlignore_default = {
  "container": "_5fNsd",
  "title": "_2--9t",
  "viewerContainer": "eklqb",
  "titleContainer": "OXnhv",
  "expandIcon": "Cl8JD",
  "dndIcon": "j4oDm",
  "RTL": "-bX1e",
  "LTR": "PHvto",
  "itemContainer": "eCyYX",
  "itemContainerViewer": "MJp5j",
  "mouseDown": "N00im",
  "innerEditor": "zPDuZ",
  "item": "Y-pfv",
  "floatingAddPluginMenuWrapper": "Sllv1"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
